"use client";
import { UiItem } from "@/src/data/allTypes";
import { useAiWindowHook } from "./aiWindowHook";
import { createContext, useContext } from "react";
import { uid } from "@/src/utils/utils";
export const ParentIdContext = createContext<string | null>(null);

export function AiDescription({
  item,
  children,
}: {
  item: UiItem;
  children: any;
}) {
  // return children;
  // item.content ||= children;
  const parentId = useContext(ParentIdContext);
  item.parentId = parentId;
  const { uniqueId } = useAiWindowHook({ item });

  return (
    <ParentIdContext.Provider value={uniqueId}>
      {children}
    </ParentIdContext.Provider>
  );
}

export function addPromiseToWindow(id?: string | null | undefined) {
  if (!id) id = uid();
  (window as any).promises ||= {};
  (window as any).promises[id] = true;
  return id;
}

export function removePromiseFromWindow(id: string) {
  (window as any).promises ||= {};
  delete (window as any).promises[id];
}

export function awaitWindowPromise(id: string) {
  return new Promise((resolve, reject) => {
    (window as any).promises ||= {};
    if (!(window as any).promises[id]) {
      resolve(null);
      return;
    }
    setInterval(() => {
      if (!(window as any).promises[id]) resolve(null);
    }, 100);
  });
}

export function awaitAllWindowPromises() {
  return new Promise((resolve, reject) => {
    (window as any).promises ||= {};
    if (Object.keys((window as any).promises).length == 0) resolve(null);
    setInterval(() => {
      if (Object.keys((window as any).promises).length == 0) resolve(null);
    }, 100);
  });
}
